import { createHealthReportAttachment,downloadHealthReport } from './downloadReport';
import { createStandardReportAttachment,downloadStandardReport } from './standardReportPdf';

// Never fall back to a Timesheet report for an unknown assessment type.
export async function createAssessmentReportAttachment(assessment,answers,contact) {
  if(assessment?.reportType==='timesheet' && assessment.id==='timesheet-to-invoice')
    return createHealthReportAttachment(answers,contact);
  if(assessment?.report?.type==='standard')
    return createStandardReportAttachment(assessment,answers,contact);
  throw new Error('No approved report template for this assessment');
}
export async function downloadAssessmentReport(assessment,answers,contact) {
  if(assessment?.reportType==='timesheet' && assessment.id==='timesheet-to-invoice')
    return downloadHealthReport(answers,contact);
  if(assessment?.report?.type==='standard')
    return downloadStandardReport(assessment,answers,contact);
  throw new Error('No approved report template for this assessment');
}